import { Alert } from 'components/commons/alert'
import { DevelopmentSummaryList } from 'components/hr-metrics/development-summary/DevelopmentSummaryList'
import { INITIAL_DATA_QUERY } from 'configs/hr-metrics/configTableDevelopmentSummary'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { API_DEVELOPMENT_SUMMARY } from 'services/apiDevelopmentSummary'
import { useFetch } from 'services/useFetch'
import { getAllQueryParams, setQueryParams } from 'utils/utils'

const DevelopmentSummaryListContainer = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_QUERY
    const [isShowToast, setIsShowToast] = useState(false)
    const [toastMessage, setToastMessage] = useState('')
    const [period, setPeriod] = useState(null)
    const [modal, setModal] = useState({
        create: false,
        limit: false,
    })
    const {
        data: developmentSummaryList,
        fetching: getDevelopmentSummaryList,
        isLoading,
    } = useFetch(API_DEVELOPMENT_SUMMARY.LIST)
    const { fetching: createPeriod, isLoading: isLoadingCreate } = useFetch(API_DEVELOPMENT_SUMMARY.CREATE_PERIOD)

    useEffect(() => {
        getDevelopmentSummaryList({ ...query })
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const clearToast = () => {
        setIsShowToast(false)
        setToastMessage('')
    }

    const setShowModal = (value) => {
        setModal({ ...modal, ...value })
    }

    const onCreatePeriod = () => {
        createPeriod({ year: period })
            .then(() => {
                setPeriod(null)
                setShowModal({ create: false })
                setIsShowToast(true)
                setToastMessage('Period Created Successfully !!')
                getDevelopmentSummaryList({ ...query })
            })
            .catch(() => {
                setPeriod(null)
                Alert({
                    icon: 'error',
                    title: 'Oops!',
                    message: 'Periode yang di pilih sudah digunakan',
                })
            })
    }

    const onClickDetail = (id) => {
        navigate(`/human-resource-metrics/employee-development-summary/detail-development-summary?periodId=${id}`)
    }

    const props = {
        dataList: developmentSummaryList?.data,
        isLoading,
        query,
        toast: {
            isShowToast,
            message: toastMessage,
        },
        modal,
        period,
        isLoadingCreate,
        clearToast,
        setShowModal,
        onChangeQuery,
        setPeriod,
        onCreatePeriod,
        onClickDetail,
    }

    return <DevelopmentSummaryList {...props} />
}

export default DevelopmentSummaryListContainer
